import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { getListingFullAddressString } from 'common/listingHelpers';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import { SR_API_ACTION_PARTNER_MARK_MARKETING_LISTING_RESOLVED } from 'api/actionTypes';

import { DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS } from 'common/dataTableConstants';

import { actionDataTableReset } from 'client/helpers/dataTables';

import postWithState from 'client/actions/postWithState';

import SrFooterButton from 'client/components/SrFooterButton/SrFooterButton';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrPartnerPageV2, {
  SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL,
} from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

class SrPartnerMarkAsResolvedForm extends Component {
  static propTypes = {
    marketingPartnerListing: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      shouldShowSuccessModal: false,
      shouldShowLoadingScreen: false,
    };
  }

  _onSubmit = (formValues) => {
    const { dispatch, marketingPartnerListing, onSubmit } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_MARK_MARKETING_LISTING_RESOLVED,
      payload: {
        marketingPartnerListingId: marketingPartnerListing.id,
        notes: formValues.notes,
        availableForSetupDate:
          formValues.availableForSetupDate || marketingPartnerListing.availableForSetupDate,
      },
    }).then(() => {
      setTimeout(() => {
        onSubmit();
      }, 1000);
      return dispatch(actionDataTableReset, {
        dataSource: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
      });
    });
  };

  _getFormFields = () => {
    return [
      {
        id: 'availableForSetupDate',
        title: 'Date available for setup?',
        type: 'date_picker',
        properties: {
          placeholder: 'MM/DD/YYYY',
          dateFormat: 'MM/DD/YYYY',
        },
        validations: ['required', 'noPastDates'],
      },
      {
        id: 'notes',
        title: 'Notes for the Sunroom team',
        titleSecondary: '(optional)',
        properties: {
          placeholder: 'Write here...',
        },
        type: 'long_text',
      },
    ];
  };

  render() {
    const { marketingPartnerListing, onBack } = this.props;

    const { shouldShowSuccessModal, shouldShowLoadingScreen } = this.state;

    if (shouldShowLoadingScreen) {
      return <div className="loading-gif" />;
    }

    return (
      <Formik
        ref={(formik) => {
          this.formik = formik;
        }}
        validate={(values) => {
          const formFields = this._getFormFields();
          return createFormValidationFn(formFields)(values);
        }}
        onSubmit={(formValues) => {
          this._onSubmit(formValues);
        }}
      >
        {(formikBag) => {
          return (
            <>
              <Form className="form">
                <SrPartnerPageV2
                  onBack={onBack}
                  navbarTitle={getListingFullAddressString(marketingPartnerListing.listing)}
                  pageHeader="Write a 'Resolved' Note"
                  headerSize={SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL}
                  pageSubtitle="What would you like us to know about how it was resolved?"
                >
                  <SrBox
                    backgroundColor="#ffffff"
                    borderRadius="14px"
                    padding="22px 19px 26px 19px"
                  >
                    {this._getFormFields().map((formField, index) => (
                      <SrFormikField
                        formField={formField}
                        formikBag={formikBag}
                        theme={SR_FIELD_THEME_ADOBE}
                        margin={index === 0 ? '0px' : null}
                        key={formField.id}
                      />
                    ))}
                  </SrBox>
                </SrPartnerPageV2>
                <SrStaticFooter>
                  <SrText
                    display="block"
                    lineHeight="25px"
                    font="greycliff"
                    color="grey600"
                    fontSize="13px"
                    weight="500"
                  >
                    Updates can take 24 hours to syndicate
                  </SrText>
                  <SrFooterButton disabled={!formikBag.isValid} hasBoxShadow={formikBag.isValid}>
                    Mark As Resolved
                  </SrFooterButton>
                </SrStaticFooter>
              </Form>
              {shouldShowSuccessModal && (
                <SrSimpleMessageModal
                  iconUrl="/images/checkmark-circle-large-green.svg"
                  headline="Saved!"
                  maxWidth="375"
                  minWidth="320"
                  theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
                />
              )}
            </>
          );
        }}
      </Formik>
    );
  }
}

SrPartnerMarkAsResolvedForm.displayName = 'SrPartnerMarkAsResolvedForm';

export default SrPartnerMarkAsResolvedForm;
